import { companyType } from "../Utils/environment";
import { CompanyType } from "./CompanyType";

export enum PermissionKpasType {
    READ_STATISTICS = 'requestkpasstatistics_read',
    READ_ASSEMBLIES = 'requestkpasreport_read',
    READ_ALL_REQUESTS = 'requestkpasforeign_read',
}

export enum PermissionKoopType {
    READ_STATISTICS = 'requeststatistics_read',
    READ_ASSEMBLIES = 'requestreport_read',
    READ_ALL_REQUESTS = 'requestforeign_read',
}

export const PermissionType = companyType === CompanyType.KOOPERATIVA ? PermissionKoopType : PermissionKpasType;
export type PermissionType = PermissionKoopType | PermissionKpasType;

export const isPermissionType = (value: string): value is PermissionType => {
    return Object.values(PermissionType).includes(value as PermissionType);
}
